<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <el-form label-width="130px"
               style="margin-top: 5px"
               :model="dataForm"
               :rules="rules"
               ref="ruleForm">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业名称"
                          prop="companyName">
              <el-input v-model="dataForm.companyName"
                        placeholder="企业名称"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用码"
                          prop="socialCreditCode">
              <el-input v-model="dataForm.socialCreditCode"
                        placeholder="统一社会信用代码"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- todo -->
          <el-col :span="12">
            <el-form-item label="企业负责人">
              <el-input v-model="dataForm.user"
                        placeholder="企业负责人"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <!-- todo -->
          <el-col :span="12">
            <el-form-item label="企业负责人电话">
              <el-input v-model="dataForm.user"
                        placeholder="企业负责人电话"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <!-- todo -->
            <el-form-item label="所属行业">
              <el-select v-model="dataForm.value"
                         style="width: 30%;float:left"
                         placeholder="大类">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.value"
                         style="width: 65%;float:left;margin-left:5%"
                         placeholder="小类">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务类型">
              <el-select v-model="dataForm.nature"
                         style="width: 100%;"
                         placeholder="业务类型">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业地址"
                          prop="dizhi">
              <el-select v-model="dataForm.dizhi.provinceId"
                         style="width: 30%;float:left"
                         placeholder="省">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.dizhi.cityId"
                         style="width: 30%;float:left;margin-left:5%"
                         placeholder="市">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.dizhi.areaId"
                         style="width: 30%;float:left;margin-left:5%"
                         placeholder="区">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="dataForm.dizhi.address"
                        placeholder="详细地址：如街道，道路，园区门牌号等"
                        style="width: 100%;margin-top:10px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业法人"
                          prop="legaPerson">
              <el-input v-model="dataForm.legaPerson"
                        placeholder="企业法人"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="法人身份证"
                          prop="legaIdcard">
              <el-input v-model="dataForm.legaIdcard"
                        placeholder="法人身份证"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- todo -->
            <el-form-item label="营业执照">
              <div class="demo-image__preview">
                <el-image style="width: 200px; height: 130px"
                          :src="url"
                          :preview-src-list="srcList">
                </el-image>
              </div>
              <el-upload class="upload-demo"
                         :action="action"
                         :with-credentials="true"
                         :headers="myHeaders"
                         :on-change="handleChange"
                         :before-upload="beforeUpload"
                         :file-list="fileList">
                <el-button size="small"
                           type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <!-- todo -->
            <el-form-item label="法人身份证(正面)">
              <el-image style="width: 200px; height: 130px"
                        :src="url"
                        :preview-src-list="srcList">
              </el-image>
              <el-upload class="upload-demo"
                         :action="action"
                         :with-credentials="true"
                         :headers="myHeaders"
                         :on-change="handleChange"
                         :before-upload="beforeUpload"
                         :file-list="fileList">
                <el-button size="small"
                           type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- todo -->
            <el-form-item label="法人身份证(反面)">
              <div class="demo-image__preview">
                <el-image style="width: 200px; height: 130px"
                          :src="url"
                          :preview-src-list="srcList">
                </el-image>
                <el-upload class="upload-demo"
                           :action="action"
                           :with-credentials="true"
                           :headers="myHeaders"
                           :on-change="handleChange"
                           :before-upload="beforeUpload"
                           :file-list="fileList">
                  <el-button size="small"
                             type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer">
        <el-button type="primary"
                   style="margin-right: 10px"
                   @click="save()">保存</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data () {
    var validateAdress = (rule, value, callback) => {
      if (!value.address) {
        callback(new Error('地址不能为空'))
      } else if (!value.provinceId) {
        callback(new Error('省不能为空'))
      } else if (!value.cityId) {
        callback(new Error('市不能为空'))
      } else if (!value.areaId) {
        callback(new Error('区不能为空'))
      }
    }
    return {
      dataForm: {
        dizhi: {}
      },
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      fileList: [],
      action: '',
      myHeaders: {},
      rules: {
        companyName: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        // 地址
        dizhi: [
          { required: true, validator: validateAdress, trigger: 'blur' }
        ],
        // 企业法人
        legaPerson: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        // 企业法人身份证
        legaIdcard: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleChange () {

    },
    beforeUpload () {

    },
    save () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('确定要新增该客户吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false,
            closeOnPressEscape: false
          }).then(() => {
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消新增'
            })
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 60px;
  margin-top: 10px;
  text-align: center;
}
</style>
<style>
.aui-content > .el-tabs > .el-tabs__content {
  padding: 10px;
}
.el-upload-list {
  display: none;
}
</style>
